<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  ref="master"
                  modalWidth="80%"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha de reporte')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['report_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha inicio de licencia')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['start_license', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fecha fin de licencia')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_license', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Fin de lactancia')" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_breastfeeding_period', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Observación')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['observation', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipoRecomendacion: {h_lookup_type: 'TYPE_MEDICAL_RECOMMEN', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'pregnancy',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_pregnancy'
            },
            columns: [
              {title: 'ID Embarazo', dataIndex: 'id_pregnancy', sorter: true},
              {title: 'Fecha de reporte', dataIndex: 'fecha_reporte', sorter: true},
              {title: 'Inicio de licencia', dataIndex: 'fecha_inicio_licencia', sorter: true},
              {title: 'Fin de licencia', dataIndex: 'fecha_fin_licencia', sorter: true},
              {title: 'Fin de lactancia', dataIndex: 'fecha_fin_lactancia', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'report_date'},
            {name: 'start_license'},
            {name: 'end_license'},
            {name: 'end_breastfeeding_period'},
            {name: 'observation'}
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/EmbarazoActual.vue